import React from "react";
import { formatNumber } from "./utils";

const TopVideosCard = ({ videos }) => {
  const topVideos = [...videos]
    .sort((a, b) => (b.video?.count_views || 0) - (a.video?.count_views || 0))
    .slice(0, 5);

  if (topVideos.length === 0) {
    return (
      <p className="text-sm text-theme-text opacity-50">No videos yet.</p>
    );
  }

  return (
    <div className="space-y-3">
      {topVideos.map((item, idx) => {
        const video = item.video;
        const creator = item.creator;
        const title = video?.title || video?.platform_id || "—";
        const creatorName = creator?.name || creator?.platform_id || "—";
        const views = video?.count_views ?? 0;
        return (
          <div
            key={item.hash}
            className="flex items-center gap-3 p-3 bg-theme-main rounded-lg"
          >
            <div className="w-6 h-6 rounded-full bg-theme-primary bg-opacity-20 flex items-center justify-center text-xs font-bold text-theme-primary flex-shrink-0">
              {idx + 1}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-theme-text truncate font-medium">{title}</p>
              <p className="text-xs text-theme-text opacity-50 truncate">{creatorName}</p>
            </div>
            <span className="text-sm font-semibold text-theme-text flex-shrink-0">
              {formatNumber(views)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default TopVideosCard;
